import { observer } from "mobx-react-lite";
import {
  Button,
  Checkbox,
  Container,
  Grid,
  Input,
  TextArea,
} from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PageHeader from "../../../app/layout/PageHeader";

export default observer(function EmailDefaults() {
  const { t } = useTranslation(["common", "ticketSettings"]);

  return (
    <>
      <PageHeader
        header={t("Email Defaults", { ns: "common" })}
        type="h2"
        divider
        getAlerts={true} addTitle={true}      />

      <Container className="page">
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Input placeholder="From Address..." label="From Address:" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input placeholder="Draft Subject" label="Draft Subject:" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
            <TextArea placeholder='Draft Body' />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input placeholder="Draft Signature" label="Draft Signature:" />
            </Grid.Column>
            </Grid.Row>
            <Grid.Row>
            <Grid.Column>
              <Checkbox
                label={t("Add Logo?", {
                  ns: "ticketSettings",
                })}
                name="addLogoToEmail"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Button
                color="green"
                className="save_button"
                icon="check"
                content={t("save", { ns: "common" })}
                type="submit"
              />
              <Button
                className="save_button"
                as={Link}
                to="/settings"
                icon="cancel"
                type="reset"
                content={t("cancel", { ns: "common" })}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </>
  );
});
